import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chevronLabel: {
		id: 'deployments.common.components.table.components.list-item.chevron-label',
		defaultMessage: 'Show children',
		description:
			"Button icon label. Button expands and collapses an item in the Roadmap's issue list.",
	},
});
